
jQuery(function($) {
    // Remove date archive link from recent post dates
    const dateLink = $('.wp-block-getwid-recent-posts__post-date a');
    dateLink.attr('href', '');
    dateLink.click(function(e){
        e.preventDefault();
        return false;
    })
});
